import React from 'react';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import Modal, { ModalHeader, ModalFooter, ModalScrollable, ModalTitle } from 'components/modal';
import Button from 'components/button';

const OtherDateModal = ({
  open,
  onClose,
  onChange,
  filterDate,
  filterTime,
  timeIntervals = 60,
  minDate
}) => {
  const [localDate, setLocalDate] = React.useState();

  const handleConfirm = () => {
    localDate && onChange(localDate);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      width="400px"
      height="auto"
      maxHeight="90%"
      closeOnOutsideClick>
      <ModalHeader>
        <ModalTitle>Select Date & Time</ModalTitle>
      </ModalHeader>
      <ModalScrollable>
        <PickerWrapper>
          <DatePicker
            selected={localDate}
            onChange={setLocalDate}
            filterTime={filterTime}
            filterDate={filterDate}
            showTimeSelect
            timeIntervals={timeIntervals}
            dateFormat="MMMM d, yyyy h:mm aa"
            minDate={minDate || new Date()}
            timeCaption="Time"
            inline
          />
        </PickerWrapper>
      </ModalScrollable>
      {localDate && (
        <ModalFooter>
          <ConfirmButton variant="primary" onClick={handleConfirm}>
            Select
          </ConfirmButton>
        </ModalFooter>
      )}
    </Modal>
  );
};

const PickerWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;

  .react-datepicker {
    display: block;
    width: fit-content;
    border: solid 1px #d4dae1;
  }
  .react-datepicker__time-list-item--selected,
  .react-datepicker__day--selected {
    background-color: var(--color-link) !important;
  }
  .react-datepicker__header {
    background-color: white;
    border-bottom: solid 1px #d4dae1;
  }
  .react-datepicker__time-container {
    border-left: solid 1px #d4dae1;
  }
`;

const ConfirmButton = styled(Button)`
  width: 100%;
  padding: 10px 0 !important;
  text-transform: uppercase;
  border-radius: 25px !important;
`;

export default (props) => {
  if (!props.open) return null;
  return <OtherDateModal {...props} />;
};
